import { Component, EventEmitter, HostListener, Output } from '@angular/core';

@Component({
  selector: 'keyboard-shortcuts-interceptor',
  template: ''
})
export class KeyboardShortcutsInterceptorComponent {
  @Output() onSave = new EventEmitter<void>();
  @Output() onDuplicate = new EventEmitter<void>();

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // Ctrl+S
    if (event.ctrlKey && event.key === 's' && this.onSave) {
      event.preventDefault();
      this.onSave.emit();
    }

    // Ctrl+D
    if (event.ctrlKey && event.key === 'd' && this.onDuplicate) {
      event.preventDefault();
      this.onDuplicate.emit();
    }
  }
}
